export const SET_EVENT_SCHEDULE_SUCCESS = 'SET_EVENT_SCHEDULE_SUCCESS'

const setEventSchedule = (eventSchecule) => (dispatch) => {
  dispatch({ type: SET_EVENT_SCHEDULE_SUCCESS, payload: eventSchecule })
}

export default setEventSchedule
